module.exports = __webpack_public_path__ + "img/gonganbeian.d0289dc0.png";